import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import style from './GridSkeleton.module.scss'

interface IGridSkeletonProps {
  count: number
  columns: number
  mobile?: boolean
}

// Sam's Club's grid loader: one grey card outline per product, in the grid's own columns, so the
// page keeps its height when the photos arrive. On a phone each outline follows the list row:
// photo on the left, price, title, rating, chips and the button stacked on the right.
const GridSkeleton = ({ count, columns, mobile }: IGridSkeletonProps) => {
  const { t } = useSurveyLocale()

  const card = (index: number) =>
    mobile ? (
      <div key={index} className={style.row}>
        <div className={style.rowImage} />
        <div className={style.rowBody}>
          <div className={style.price} />
          <div className={style.titleLine} />
          <div className={`${style.titleLine} ${style.short}`} />
          <div className={style.rating} />
          <div className={style.chips}>
            <div className={style.chip} />
            <div className={style.chip} />
          </div>
          <div className={style.cta} />
        </div>
      </div>
    ) : (
      <div key={index} className={style.card}>
        <div className={style.image} />
        <div className={style.title} />
        <div className={style.line} />
        <div className={style.button} />
      </div>
    )

  return (
    <div
      className={mobile ? style.list : style.grid}
      style={mobile ? undefined : { gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
      role="status"
      aria-label={t('questions', 'ec', 'loading')}
      data-testid="SW-EC-GridSkeleton"
    >
      {Array.from({ length: count }, (_, index) => card(index))}
    </div>
  )
}

export default GridSkeleton
